module.exports = __webpack_public_path__ + "static/media/IMG-23.e50d764d.jpg";